import Resource from './common/resource';

class CustomRecords extends Resource {
  path = 'custom/records';
}

export default CustomRecords;
